// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3KotA","content":"LoadingAlert_content__1xdP5"};